import { Outlet } from "react-router-dom";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";
import { Concierge } from "./Concierge";
import { SmoothScroll } from "./SmoothScroll";

export const SiteLayout = () => (
  <>
    <a href="#main" className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[300] focus:rounded-full focus:bg-orange-500 focus:px-4 focus:py-2 focus:text-black">
      Skip to content
    </a>
    <SmoothScroll />
    <Navbar />
    <main id="main">
      <Outlet />
    </main>
    <Footer />
    <Concierge />
  </>
);
